export default "__VITE_ASSET__633d0da1__"